@file:OptIn(InternalResourceApi::class)

package timesheet.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/timesheet.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_963_573_597)
internal val Res.drawable.app_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_632_862_919)
internal val Res.drawable.baseline_arrow_back_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_arrow_back_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_arrow_back_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_973_980_544)
internal val Res.drawable.baseline_arrow_back_ios_new_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_arrow_back_ios_new_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_arrow_back_ios_new_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_415_973_801)
internal val Res.drawable.baseline_article_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_article_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_article_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(47_097_489)
internal val Res.drawable.baseline_calendar_month_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_calendar_month_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_calendar_month_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_918_535_860)
internal val Res.drawable.baseline_calendar_view_day_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_calendar_view_day_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_calendar_view_day_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_275_718_434)
internal val Res.drawable.baseline_calendar_view_month_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_calendar_view_month_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_calendar_view_month_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_328_431_889)
internal val Res.drawable.baseline_info_outline_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_info_outline_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_info_outline_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_452_567_458)
internal val Res.drawable.baseline_local_shipping_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_local_shipping_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_local_shipping_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_427_665_173)
internal val Res.drawable.baseline_more_horiz_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_more_horiz_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_more_horiz_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_343_289_621)
internal val Res.drawable.baseline_note_add_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_note_add_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_note_add_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_013_892_413)
internal val Res.drawable.baseline_payments_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_payments_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_payments_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-808_309_902)
internal val Res.drawable.baseline_punch_clock_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_punch_clock_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_punch_clock_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-799_729_463)
internal val Res.drawable.baseline_receipt_long_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_receipt_long_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_receipt_long_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(319_227_615)
internal val Res.drawable.baseline_speed_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_speed_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_speed_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_978_525_131)
internal val Res.drawable.cancel_circle: DrawableResource by lazy {
      DrawableResource("drawable:cancel_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/cancel_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_357_004_050)
internal val Res.drawable.check: DrawableResource by lazy {
      DrawableResource("drawable:check", setOf(
        ResourceItem(setOf(), "${MD}drawable/check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(839_403_700)
internal val Res.drawable.check_circle: DrawableResource by lazy {
      DrawableResource("drawable:check_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_586_849_870)
internal val Res.drawable.error_circle: DrawableResource by lazy {
      DrawableResource("drawable:error_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/error_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_486_816_052)
internal val Res.drawable.holiday: DrawableResource by lazy {
      DrawableResource("drawable:holiday", setOf(
        ResourceItem(setOf(), "${MD}drawable/holiday.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_672_835_002)
internal val Res.drawable.play_circle: DrawableResource by lazy {
      DrawableResource("drawable:play_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/play_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_696_517_017)
internal val Res.drawable.pto: DrawableResource by lazy {
      DrawableResource("drawable:pto", setOf(
        ResourceItem(setOf(), "${MD}drawable/pto.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-542_883_083)
internal val Res.drawable.round_check_24: DrawableResource by lazy {
      DrawableResource("drawable:round_check_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/round_check_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_902_172_482)
internal val Res.drawable.stop_circle: DrawableResource by lazy {
      DrawableResource("drawable:stop_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/stop_circle.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_logo", Res.drawable.app_logo)
  map.put("baseline_arrow_back_24", Res.drawable.baseline_arrow_back_24)
  map.put("baseline_arrow_back_ios_new_24", Res.drawable.baseline_arrow_back_ios_new_24)
  map.put("baseline_article_24", Res.drawable.baseline_article_24)
  map.put("baseline_calendar_month_24", Res.drawable.baseline_calendar_month_24)
  map.put("baseline_calendar_view_day_24", Res.drawable.baseline_calendar_view_day_24)
  map.put("baseline_calendar_view_month_24", Res.drawable.baseline_calendar_view_month_24)
  map.put("baseline_info_outline_24", Res.drawable.baseline_info_outline_24)
  map.put("baseline_local_shipping_24", Res.drawable.baseline_local_shipping_24)
  map.put("baseline_more_horiz_24", Res.drawable.baseline_more_horiz_24)
  map.put("baseline_note_add_24", Res.drawable.baseline_note_add_24)
  map.put("baseline_payments_24", Res.drawable.baseline_payments_24)
  map.put("baseline_punch_clock_24", Res.drawable.baseline_punch_clock_24)
  map.put("baseline_receipt_long_24", Res.drawable.baseline_receipt_long_24)
  map.put("baseline_speed_24", Res.drawable.baseline_speed_24)
  map.put("cancel_circle", Res.drawable.cancel_circle)
  map.put("check", Res.drawable.check)
  map.put("check_circle", Res.drawable.check_circle)
  map.put("error_circle", Res.drawable.error_circle)
  map.put("holiday", Res.drawable.holiday)
  map.put("play_circle", Res.drawable.play_circle)
  map.put("pto", Res.drawable.pto)
  map.put("round_check_24", Res.drawable.round_check_24)
  map.put("stop_circle", Res.drawable.stop_circle)
}
